import { useState } from "react";
import { Button } from "@mui/material";
import Api from "../utils/Api";

import ChoixBadgePopup from "../composant/Dashboard/Popups/ChoixBadgePopup/ChoixBadgePopup";
import ChoixElevePopup from "../composant/Dashboard/Popups/ChoixElevePopup/ChoixElevePopup";
import "./BadgeAssignation.css";

export default function BadgeAssignation() {
  const [isChoixBadgePopupOpen, setIsChoixBadgePopupOpen] = useState(false);
  const [isChoixElevePopupOpen, setIsChoixElevePopupOpen] = useState(false);
  const [selectedEleves, setSelectedEleves] = useState([]);
  const [selectedBadges, setSelectedBadges] = useState([]);

  const assignationPossible =
    selectedBadges.length > 0 && selectedEleves.length > 0;

  const handleSelectBadge = (badge) => {
    // Faire apparaître le popup du badge ?
  };

  /**
   * Assigner les badges aux élèves sélectionnés
   *
   * @author: Félix Dupras-Simard [felixdupras@gmail.com]
   */
  const handleAssignation = () => {
    Api.post("/user/assign-multiple-badges", {
      badge_ids: selectedBadges.map((badge) => badge.id) || [],
      user_ids: selectedEleves.map((user) => user.id) || [],
    })
      .then(() => {
        const userPart =
          selectedEleves.length > 1
            ? " aux utilisateurs sélectionnés"
            : " à l'utilisateur sélectionné";
        const message =
          selectedBadges.length > 1
            ? `Les badges ont été assignés avec succès ${userPart} !`
            : `Le badge a été assigné avec succès ${userPart} !`;

        // setSuccessMessage(message);
        // setShowSuccessMessage(true);
        //handleClose();
      })
      .catch((error) => {
        console.error("Erreur Axios complète :", error);
        console.error("Réponse Laravel :", error.response?.data);
        console.error("Message Laravel :", error.response?.data?.message);
        console.error("Erreur SQL/Laravel :", error.response?.data?.error);
      })
      .finally(() => {
        setSelectedBadges([]);
        setSelectedEleves([]);
      });
  };

  return (
    <>
      <div className="ba-wrapper">
        <header className="ba-header">
          <div className="ba-header-left">
            <h1 className="ba-title">Assigner des Badges</h1>
          </div>

          <div className="ba-actions">
            <Button className="ba-btn ba-btn--outline" onClick={() => setIsChoixBadgePopupOpen(true)}>
              Choisir Badge(s)
              {selectedBadges.length > 0 && (
                <span className="ba-btn-count">{selectedBadges.length}</span>
              )}
            </Button>
            <Button className="ba-btn ba-btn--outline" onClick={() => setIsChoixElevePopupOpen(true)}>
              Choisir Élève(s)
              {selectedEleves.length > 0 && (
                <span className="ba-btn-count">{selectedEleves.length}</span>
              )}
            </Button>
          </div>
        </header>

        <div className="ba-columns">
          <section className="ba-card ba-card--badges">
            <div className="ba-card-header">
              <span className="ba-card-icon"></span>
              <h2 className="ba-card-title">Badges</h2>
              <span className="ba-card-count">{selectedBadges.length}</span>
            </div>
            <div className="ba-card-body">
              {selectedBadges.length === 0 ? (
                <div className="ba-empty">
                  <p>Aucun badge sélectionné</p>
                  <Button className="ba-empty-cta" onClick={() => setIsChoixBadgePopupOpen(true)}>
                    Choisir des badges
                  </Button>
                </div>
              ) : (
                <ul className="ba-badge-list">
                  {selectedBadges.map((badge) => (
                    <li key={badge.id} className="ba-badge-item">
                      <div className="ba-badge-img-wrap">
                        <img src={badge.imagePath} alt={badge.title} />
                      </div>
                      <span className="ba-badge-name">{badge.title}</span>
                      <Button
                        className="ba-remove-btn"
                        onClick={() =>
                          setSelectedBadges((prev) =>
                            prev.filter((b) => b.id !== badge.id),
                          )
                        }
                        aria-label={`Retirer ${badge.title}`}
                      >×</Button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </section>

          <section className="ba-card ba-card--eleves">
            <div className="ba-card-header">
              <span className="ba-card-icon"></span>
              <h2 className="ba-card-title">Élèves</h2>
              <span className="ba-card-count">{selectedEleves.length}</span>
            </div>

            <div className="ba-card-body">
              {selectedEleves.length === 0 ? (
                <div className="ba-empty">
                  <p>Aucun élève sélectionné</p>
                  <Button className="ba-empty-cta" onClick={() => setIsChoixElevePopupOpen(true)}>
                    + Choisir des élèves
                  </Button>
                </div>
              ) : (
                <ul className="ba-eleve-list">
                  {selectedEleves.map((eleve) => (
                    <li key={eleve.id} className="ba-eleve-item">
                      <span className="ba-eleve-name">
                        {eleve.first_name} {eleve.last_name}
                      </span>
                      <Button
                        className="ba-remove-btn"
                        onClick={() =>
                          setSelectedEleves((prev) =>
                            prev.filter((e) => e.id !== eleve.id),
                          )
                        }
                        aria-label={`Retirer ${eleve.first_name}`}
                      >×</Button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </section>
        </div>
        <div className="ba-footer">
          <Button
            className="ba-btn ba-btn--ghost"
            onClick={() => {
              setSelectedBadges([]);
              setSelectedEleves([]);
            }}
            disabled={!assignationPossible}
          >
            Réinitialiser
          </Button>
          <Button className={`ba-btn ba-btn--primary ${assignationPossible ? "ba-btn--glow" : ""}`} onClick={() => handleAssignation()} disabled={!assignationPossible}>
            Assigner
          </Button>
        </div>
      </div>
      <ChoixBadgePopup
        isOpen={isChoixBadgePopupOpen}
        onClose={() => {
          setIsChoixBadgePopupOpen(false);
        }}
        selectedBadges={selectedBadges}
        setSelectedBadges={setSelectedBadges}
      />

      <ChoixElevePopup
        isOpen={isChoixElevePopupOpen}
        onClose={() => {
          setIsChoixElevePopupOpen(false);
        }}
        selectedEleves={selectedEleves}
        setSelectedEleves={setSelectedEleves}
      />
    </>
  );
}
